import { createRoot } from "react-dom/client";
import { FluentProvider } from "@fluentui/react-components";
import { releaseStaleModalHiding } from "./a11y";
import { App } from "./App";
import { theme } from "./theme";
import "./styles.css";

const root = document.getElementById("root")!;
releaseStaleModalHiding(root);
createRoot(root).render(
  <FluentProvider theme={theme}>
    <App />
  </FluentProvider>,
);
